import { render, staticRenderFns } from "./TechDetail.vue?vue&type=template&id=d6ffd93a&scoped=true"
import script from "./TechDetail.vue?vue&type=script&lang=js"
export * from "./TechDetail.vue?vue&type=script&lang=js"
import style0 from "./TechDetail.vue?vue&type=style&index=0&id=d6ffd93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ffd93a",
  null
  
)

export default component.exports